import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { forcedNumber } from '../../helpers/general.helper';
import toast from 'react-hot-toast';
import { api } from '../../data/api';
import { TextField } from '../../components/formFields/TextField';
import { SmartForm } from '../../components/formFields/Form';
import { Spinner } from '../../components/spinner/Spinner.component';
import {  Especialidad, especialidadesConstants } from '../../data/types/especialidades.types';
import { CheckField } from '../../components/formFields/checkField/CheckField';
 
interface Entity extends Especialidad {}
const entityConstants = especialidadesConstants
 
export const EspecialidadesForm = () => {
 
	const { id } = useParams();
	const navigate = useNavigate();
   
	const [formData, setFormData] = useState<Partial<Entity>>({
		nombre: '',
		id: 0,
		activo: true,
	});
 
	const [loading, setLoading] = useState(!!id);
	const [errors, setErrors] = useState<Record<string, string>>({});
	 
	useEffect(() => {
		if (id) {
		  const loadData = async () => {
			try {
				setLoading(true);
				const {data} = await api.get<Entity[]>(`${entityConstants.apiEndpoint}/${id}`);
				const response: Entity = data[0];
				setFormData({
					nombre: response.nombre,
					id: forcedNumber(response.id),
					activo: response.activo,
				});
			} catch (err) {
				console.error("### error", err);
				toast.error(`Error cargando ${entityConstants.entityLabelGender === 'M' ? 'el' : 'la'} ${entityConstants.entityLabel.toLowerCase()}`);
			} finally {
				  setLoading(false);
			}
		  };
		  loadData();
		}
	}, [id]);
 
	const validateForm = () => {
		return true;
	};
 
	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
	 
		if (!validateForm()) return;
	 
		try {
		  if (id) {
			await api.post(`${entityConstants.apiEndpoint}/${id}`, formData);
		  } else {
			await api.post(entityConstants.apiEndpoint, formData);
		  }
		  toast.success(`${entityConstants.entityLabel} ${entityConstants.entityLabelGender === 'M' ? ' guardado' : ' guardada'}`);
		//   queryClient.invalidateQueries({queryKey: ['esp']});
		  navigate(entityConstants.navigateToParent);
		} catch (err) {
		  console.error("### error", err);
		  toast.error(`Error guardando `);
		}
	}
 
	if (loading) return <Spinner />
 
	return (
		<SmartForm
			title={id ? `Editar ${entityConstants.entityLabel}` : `Nuevo ${entityConstants.entityLabel}`}
			onSubmit={handleSubmit}
			cancelButtonNavigateTo={entityConstants.navigateToParent}
			confirmButtonLabel={id ? 'Actualizar' : 'Crear'}
		>
			<TextField
				label="Especialidad"
				value={formData.nombre || ''}
				onChange={(value) => setFormData({ ...formData, nombre: value })}
				error={errors.name}
				placeholder="Ej: Pediatra"
			/>

			<CheckField
				label="Activo"
				checked={formData.activo || false}
				onChange={(value) => setFormData({ ...formData, activo: value })}
				error={errors.activo}
			/>
		</SmartForm>
	)
}
